import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";

export interface MyTenantsRow {
  role: "USER" | "TENANT_ADMIN" | "TENANT_SUPERADMIN";
  tenant: {
    id: string;
    slug: string;
    name: string;
    status: "ONBOARDING" | "ACTIVE" | "SUSPENDED";
  };
}

export interface CreateTenantPayload {
  name: string;
  slug?: string;
}

export interface CreatedTenant {
  id: string;
  slug: string;
  name: string;
  status: string;
}

const MY_TENANTS_KEY = ["onboarding", "my-tenants"] as const;

export const useMyTenants = () => {
  const { data, isPending: loading, error } = useQuery({
    queryKey: MY_TENANTS_KEY,
    queryFn: async () =>
      (await axios.get<MyTenantsRow[], AxiosResponse<MyTenantsRow[]>>("/onboarding/my-tenants")).data,
    refetchInterval: 30_000,
  });
  return { tenants: data ?? [], loading, error };
};

export const useCreateTenant = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: CreateTenantPayload) =>
      (
        await axios.post<CreatedTenant, AxiosResponse<CreatedTenant>>(
          "/onboarding/tenant",
          payload,
        )
      ).data,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: MY_TENANTS_KEY });
    },
  });
};
